module.exports = __webpack_public_path__ + "img/background.26fcbdff.png";